<!-- Hero Section -->
<section id="hero">
  <app-manufacturing-hero></app-manufacturing-hero>
</section>

<!-- Overview Section -->
<section id="overview">
  <app-manufacturing-overview></app-manufacturing-overview>
</section>

<!-- Features Section -->
<section id="features">
  <app-manufacturing-features></app-manufacturing-features>
</section>
